import { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { toast } from 'sonner';
import BrandMark from '@/components/BrandMark';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Passwords don't match");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: password });
      setDone(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'This reset link is invalid or has expired');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center mb-8">
          <BrandMark size={48} />
        </div>
        <Card className="border-0 shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] rounded-3xl">
          <CardHeader className="pb-4">
            <CardTitle className="font-heading text-2xl text-fern">Reset your password</CardTitle>
            <CardDescription>{done ? 'All set' : 'Choose a new password below'}</CardDescription>
          </CardHeader>
          <CardContent>
            {!token ? (
              <p className="text-sm text-slate-600">This reset link is missing its token. Please use the link from your email.</p>
            ) : done ? (
              <div className="space-y-4">
                <p className="text-sm text-slate-600">Your password has been updated.</p>
                <Link to="/auth">
                  <Button className="w-full bg-fern hover:bg-fern-light text-white rounded-full py-3 font-medium">
                    Sign in
                  </Button>
                </Link>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <Label htmlFor="new-password">New password</Label>
                  <Input id="new-password" type="password" required minLength={6} placeholder="At least 6 characters" className="rounded-xl mt-1 bg-slate-50 focus:bg-white" value={password} onChange={e => setPassword(e.target.value)} />
                </div>
                <div>
                  <Label htmlFor="confirm-password">Confirm password</Label>
                  <Input id="confirm-password" type="password" required minLength={6} placeholder="Re-enter password" className="rounded-xl mt-1 bg-slate-50 focus:bg-white" value={confirm} onChange={e => setConfirm(e.target.value)} />
                </div>
                <Button type="submit" disabled={loading} className="w-full bg-fern hover:bg-fern-light text-white rounded-full py-3 font-medium mt-2">
                  {loading ? 'Saving...' : 'Set new password'}
                </Button>
              </form>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
